module.exports = __webpack_public_path__ + "img/file-type-pdf.9881eba3.svg";